import React, { useEffect, useState } from 'react';
import { isEmpty, isNil } from 'lodash';
import { get } from '../../common/httpService';
import translateService from '../../common/translateService';
import CmsModules from '../../services/cms/CmsModules';
import ProductSlider from './products/ProductSlider.jsx';

import './GridProducts.scss';

const GridProducts = ({
    showButtonAndTitle,
    component,
    slug,
    numberOfProducts,
}) => {
    const [componentInfo, setComponentInfo] = useState({
        cssClass: '',
        translationInterpolation: '',
        url: '',
    });
    const [products, setProducts] = useState({
        products: [],
        link: '',
        name: '',
    });

    const getProducts = async (url) => {
        const data = await get({ url: url });
        setProducts(data);
    };

    useEffect(() => {
        switch (component) {
            case CmsModules.LatestArrivals:
                setComponentInfo({
                    cssClass: 'latest-arrivals',
                    translationInterpolation: 'latestArrivals',
                    url: `ProductBrowse/GetLatestArrivals?pageSize=${
                        isNil(numberOfProducts) ? 8 : numberOfProducts
                    }&availableOnly=true`,
                });
                break;
            case CmsModules.Offers:
                setComponentInfo({
                    cssClass: 'offers',
                    translationInterpolation: 'offers',
                    url: `ProductBrowse/GetProductsOnOffer?pageSize=${
                        isNil(numberOfProducts) ? 8 : numberOfProducts
                    }&availableOnly=true`,
                });
                break;
            case CmsModules.Category:
                setComponentInfo({
                    cssClass: 'category',
                    translationInterpolation: 'category',
                    url: `ProductBrowse/GetProductsFromCategory?pageSize=${
                        isNil(numberOfProducts) ? 8 : numberOfProducts
                    }&categorySlug=${slug}&availableOnly=true`,
                });
                break;
            default:
                break;
        }
    }, [component]);

    useEffect(() => {
        if (!isEmpty(componentInfo.url)) {
            getProducts(componentInfo.url);
        }
    }, [componentInfo.url]);

    return products.products.length > 0 ? (
        <>
            {showButtonAndTitle && (
                <div className='section__title-container'>
                    <h1 className='section__title grid_home-products_title'>
                        {component === CmsModules.Category
                            ? products.name
                            : translateService.get(
                                  `home.${componentInfo.translationInterpolation}`
                              )}
                    </h1>
                    <a
                        className='grid_home-products_button button button--primary'
                        href={products.link}>
                        {translateService.get(
                            `home.${componentInfo.translationInterpolation}ViewAll`
                        )}
                    </a>
                </div>
            )}
            <ProductSlider products={products.products} />
        </>
    ) : (
        <></>
    );
};

export default GridProducts;
